export function DashboardSectionHeader({
  title,
  subtitle,
  prominent = false,
}: {
  title: string;
  subtitle?: string;
  prominent?: boolean;
}) {
  return (
    <div className="mb-3">
      <h2 className={prominent ? "text-xl font-semibold tracking-tight text-slate-900" : "text-sm font-semibold text-slate-900"}>{title}</h2>
      {subtitle ? <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p> : null}
    </div>
  );
}
